import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '../lib/animations';
import { ArrowUpRight } from 'lucide-react';
const products = [{
  id: 1,
  title: 'Heritage Cotton Sarees',
  description: 'Intricate woven patterns with rich, vibrant dyes.',
  image: 'https://encrypted-tbn0.gstatic.com/shopping?q=tbn:ANd9GcQHQ9leRMcak1voYjfTcsP2z72OtD3O74PxUgx-nvrhjyi4mR1aTktgeZI1BieFOATWqs8HtnJcHyA_N-PtLty8qJk2CfPwglGeYzhvNIEHlaNgF103EU7yRw',
  category: 'Ethnic Wear'
}, {
  id: 2,
  title: 'Premium Cotton Kurtas',
  description: 'Breathable, natural textures for superior comfort.',
  image: 'https://fabloe.in/cdn/shop/files/fabloe-8844.jpg?v=1744094986',
  category: "Men's Wear"
}, {
  id: 3,
  title: 'Fine Cotton Shirting',
  description: 'Crisp, high-thread-count weaves for professional attire.',
  image: 'https://ramrajcotton.in/cdn/shop/files/ACF441S-C11C.jpg?v=1745236778',
  category: 'Fabrics'
}, {
  id: 4,
  title: 'Embellished Blouse Pieces',
  description: 'Detailed embroidery on premium base fabrics.',
  image: 'https://m.media-amazon.com/images/I/918xJsuwJnL._AC_UY1100_.jpg',
  category: 'Components'
}, {
  id: 5,
  title: 'Raw Textile Weaves',
  description: 'Unprocessed fabrics ready for industrial dyeing.',
  image: 'https://i.etsystatic.com/17500931/r/il/a22c76/4880743279/il_fullxfull.4880743279_cy8d.jpg',
  category: 'Manufacturing'
}, {
  id: 6,
  title: 'Custom Export Orders',
  description: 'Tailored manufacturing for global fashion houses.',
  image: 'https://cdn.shopify.com/s/files/1/0669/1684/3771/files/The-Various-Types-of-Fabrics-and-How-to-Clean-Them.jpg',
  category: 'B2B Services'
}];
export function Products() {
  return <section id="products" className="py-24 md:py-32 bg-white" data-id="element-129">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={staggerContainer} className="mb-20 text-center max-w-3xl mx-auto" data-id="element-131">
          <motion.span variants={fadeInUp} className="text-[#dc2626] font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-132">
            Our Collection
          </motion.span>
          <motion.h2 variants={fadeInUp} className="text-4xl md:text-5xl font-bold text-[#1e3a8a] mb-6" data-id="element-133">
            Curated Textile Excellence
          </motion.h2>
          <motion.p variants={fadeInUp} className="text-gray-600 text-lg leading-relaxed" data-id="element-134">
            Discover our range of premium fabrics and garments, manufactured
            with precision for the discerning global market.
          </motion.p>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={staggerContainer} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10" data-id="element-135">
          {products.map(product => <motion.div key={product.id} variants={fadeInUp} className="group cursor-pointer" data-id="element-136">
              <div className="relative overflow-hidden rounded-2xl aspect-[4/5] mb-6 bg-gray-100" data-id="element-137">
                <motion.img whileHover={{
              scale: 1.1
            }} transition={{
              duration: 0.6,
              ease: [0.22, 1, 0.36, 1]
            }} src={product.image} alt={product.title} className="w-full h-full object-cover" data-id="element-138" />
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-139"></div>
                <div className="absolute top-4 left-4" data-id="element-140">
                  <span className="bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-[#1e3a8a] uppercase tracking-wide" data-id="element-141">
                    {product.category}
                  </span>
                </div>
                <div className="absolute bottom-4 right-4 bg-white rounded-full p-3 opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 shadow-lg" data-id="element-142">
                  <ArrowUpRight className="w-5 h-5 text-[#1e3a8a]" data-id="element-143" />
                </div>
              </div>
              <div data-id="element-144">
                <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-[#1e3a8a] transition-colors" data-id="element-145">
                  {product.title}
                </h3>
                <p className="text-gray-500 leading-relaxed" data-id="element-146">
                  {product.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}